import React from 'react';
import { Outlet } from 'react-router-dom';

const MentorsPage = () => {
  return <Outlet />;
};

export default MentorsPage;
